import { Link } from 'react-router-dom';

import InlineScript from './InlineScript';

import { LOGO_ALT, LOGO_SRC } from '../constants/branding';
import './footer.css';

export default function Footer() {
  return (
    <div className="footer-container1">
      <footer className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand-column">
              <div className="footer-logo-container">
                <img
                  src={LOGO_SRC}
                  alt={LOGO_ALT}
                  className="footer-logo-img"
                  width={200}
                  height={80}
                />
              </div>
              <p className="footer-brand-description section-content">
                Professional painting and renovation services in Burnaby and
                surrounding areas. We bring a &quot;shiny touch&quot; to every
                home and strata property we maintain.
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="Facebook" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 10v4h3v7h4v-7h3l1-4h-4V8a1 1 0 0 1 1-1h3V3h-3a5 5 0 0 0-5 5v2z"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/shinytouchpainting/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div aria-label="Instagram" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"></path>
                        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0m7.5-4.5v.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M8 11v5m0-8v.01M12 16v-5m4 5v-3a2 2 0 1 0-4 0"></path>
                        <path d="M3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-links-column">
              <h3 className="footer-column-title section-subtitle">
                Quick Links
              </h3>
              <ul className="footer-nav-list">
                <li className="footer-nav-item">
                  <Link to="/">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>Homepage</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link to="/services">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>Our Services</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link to="/before-after-gallery">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>Work Gallery</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link to="/about">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>About Us</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link to="/request-a-free-quote">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>Get a Quote</span>
                    </div>
                  </Link>
                </li>
                <li className="footer-nav-item">
                  <Link to="/contact">
                    <div className="footer-nav-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-6 6l6-6m-6-6l6 6"
                        ></path>
                      </svg>
                      <span>Contact Us</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-contact-column">
              <h3 className="footer-column-title section-subtitle">
                Contact Details
              </h3>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <div className="footer-contact-icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <span className="footer-contact-label">Email Us</span>
                    <a href="mailto:info@shinytouchpainting.ca?subject=">
                      <div className="footer-contact-link">
                        <span>info@shinytouchpainting.ca</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <span className="footer-contact-label">Call Now</span>
                    <a href="tel:+17788280572">
                      <div className="footer-contact-link">
                        <span>(778) 828-0572</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <span className="footer-contact-label">Location</span>
                    <address className="footer-contact-address">
                      <span>99632 Market Crossing PO, Burnaby, BC V5J 0H7</span>
                    </address>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p className="section-content">
                © {new Date().getFullYear()} Shiny Touch Painting &amp;
                Renovation Ltd. All Rights Reserved.
              </p>
            </div>
            <div className="footer-legal-links">
              <a href="#">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Terms of Service</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <InlineScript
            html={`<script defer data-name="footer-interactions">
(function(){
  const footerSocialIcons = document.querySelectorAll(".footer-social-icon")

  footerSocialIcons.forEach((icon) => {
    icon.addEventListener("mouseenter", () => {
      icon.style.transition = "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
    })

    icon.addEventListener("mouseleave", () => {
      icon.style.transition = "all 0.3s ease"
    })
  })

  const footerNavLinks = document.querySelectorAll(".footer-nav-link")

  footerNavLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      const icon = link.querySelector("svg")
      if (icon) {
        icon.style.transform = "translateX(6px) scale(1.1)"
      }
    })

    link.addEventListener("mouseleave", () => {
      const icon = link.querySelector("svg")
      if (icon) {
        icon.style.transform = "translateX(0) scale(1)"
      }
    })
  })
})()
</script>`}
          ></InlineScript>
        </div>
      </div>
    </div>
  );
}
